import autobind from "autobind-decorator";
import type { FieldRenderProps } from "react-final-form";
import type { CommonOption } from "@/shared/ui";
import { TEAOR_CODES } from "./data/FormTeaor.data";
import type { FormInputProps } from "./FormInput";
import { FormInput } from "./FormInput";

const TEAOR_DATA_LIST = [...TEAOR_CODES.map((v) => v.label), ...TEAOR_CODES.map((v) => `${v.value} - ${v.label}`)];

export type FormTeaorProps = FormInputProps<string>;

export class FormTeaor extends FormInput<string, FormTeaorProps> {
	public static defaultProps: Partial<FormTeaorProps> = {
		dataList: TEAOR_DATA_LIST,
	};

	@autobind
	protected handleBlur(event: React.FocusEvent<HTMLElement>, fieldProps: FieldRenderProps<string>): void {
		const {
			input: { onBlur, value },
		} = fieldProps;

		onBlur(event);

		if (this.props.onBlur) {
			this.props.onBlur(value, event);
		} else {
			const item = this.findTeaorItem(fieldProps.input.value);

			if (!item) {
				return;
			}
			this.handleChange(`${item.value} - ${item.label}`, fieldProps);
		}
	}

	@autobind
	protected handleValidate(value: string, allValues: Record<string, any>): string {
		const { validate } = this.props;

		if (this.isDisabled()) {
			return undefined;
		}

		if (validate) {
			return validate(value, allValues);
		}

		return this.validTeaor(value);
	}

	private validTeaor(value: string): string {
		const teaorItem = this.findTeaorItem(value);

		if (!teaorItem) {
			return "Ismeretlen TEÁOR azonosító!";
		}
	}

	private findTeaorItem(teaor: string): CommonOption<string, string> {
		if (teaor) {
			return TEAOR_CODES.find((item) => {
				const name = item.label.toLocaleLowerCase();
				const code = item.value;

				return [`${code} - ${name}`, name, code].includes(teaor.toLocaleLowerCase());
			});
		}
	}
}
